import $ from 'jquery';

window.$ = $;
window.jQuery = $;

import selectize from 'selectize';

const selectizeDefaults = {
    plugins: ['remove_button'],
    closeAfterSelect: true,
    copyClassesToDropdown: false
};

$.selectize = selectize;

$(document).on('click', '.js-selectize', function (e) {
    if ($(e.target).is('.js-selectize')) {
        $(this)
            .find('input')
            .focus();
    }
});

initSelectize();

export function initSelectize() {
    $('select.js-selectize').each(function () {
        //  already initialized
        if ($(this).is('.selectized')) return;

        const config = JSON.parse(this.dataset.config || '{}');

        const $select = $(this).selectize({
            ...selectizeDefaults,
            ...config
        });

        $(this)
            .parent()
            .find('.js-selectize-clear')
            .on('click', function () {
                $select[0].selectize.clear();
            });
    });

    $('select.js-selectize-wire').each(function () {
        // Skip already initialized select elements
        if ($(this).is('.selectized')) return;

        const url = this.dataset.remoteUrl;

        //  Only fetch options remotely when the server exposes a search endpoint,
        //  otherwise keep using the full option list rendered in the markup
        const remoteConfig = url
            ? {
                  valueField: 'uuid',
                  labelField: 'label',
                  searchField: 'label',
                  preload: false,
                  loadThrottle: 300,
                  load: (query, callback) => {
                      fetch(`${url}?q=${encodeURIComponent(query)}`, {
                          credentials: 'same-origin',
                          headers: { Accept: 'application/json' }
                      })
                          .then((response) => {
                              if (!response.ok) throw new Error(`Search failed: ${response.status}`);

                              return response.json();
                          })
                          .then(callback)
                          .catch((error) => {
                              console.error(error);
                              callback();
                          });
                  }
              }
            : {};

        const $select = $(this).selectize({
            plugins: ['remove_button'],
            closeAfterSelect: true,
            copyClassesToDropdown: false,
            ...remoteConfig,
            onChange: (value) => {
                Livewire.dispatch('updateSearch', { detail: { value }}); // Emit a Livewire event
            }
        });


        $(this)
            .parent()
            .find('.js-selectize-clear')
            .on('click', function () {
                $select[0].selectize.clear();
            });
    });
}
